import React from "react";
import { ThemeProvider, createTheme, Button as MuiButton, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, OutlinedInput } from "@mui/material";
import Close from "@mui/icons-material/Close";
import "./ScheduleEditor.css";

const theme = createTheme({
  palette: { primary: { main: "#005da8" }, text: { primary: "#243b48", secondary: "#526976" } },
  typography: { fontFamily: '"Poppins", sans-serif', fontSize: 14, button: { textTransform: "none", fontWeight: 600, fontSize: "0.875rem" } },
  shape: { borderRadius: 8 },
  components: {
    MuiButton: { defaultProps: { disableElevation: true }, styleOverrides: { root: { minHeight: 40, padding: "8px 16px" } } },
    MuiOutlinedInput: { styleOverrides: { root: { fontSize: "0.875rem", background: "#fff" }, notchedOutline: { borderColor: "#ccd8df" } } },
    MuiTab: { styleOverrides: { root: { textTransform: "none", fontSize: "0.875rem", fontWeight: 500 } } },
  },
});

export const ScheduleEditorTheme = ({ children }) => <ThemeProvider theme={theme}>{children}</ThemeProvider>;

export function Button({ variant = "contained", isLoading, disabled, children, ...props }) {
  return <MuiButton variant={variant === "secondary" ? "outlined" : variant} disabled={disabled || isLoading}
    startIcon={isLoading ? <CircularProgress size={16} color="inherit" /> : undefined} {...props}>{children}</MuiButton>;
}

// Keep native date/time entry and its browser picker inside the standard MUI field.
export const EditorInput = ({ className = "", "aria-label": ariaLabel, "aria-describedby": describedBy, ...props }) => <OutlinedInput className={`schedule-mui-input ${className}`} size="small" fullWidth inputProps={{ "aria-label": ariaLabel, "aria-describedby": describedBy }} {...props} />;

export function EditorDialog({ open, onClose, title, description, wide = false, busy = false, children, actions }) {
  return <ScheduleEditorTheme><Dialog open={open} onClose={(_, reason) => { if (!busy && reason !== "backdropClick") onClose(); }}
    maxWidth={wide ? false : "md"} fullWidth aria-labelledby={wide ? "work-editor-title" : "type-picker-title"}
    className="scheduling-dialog schedule-editor-dialog"
    PaperProps={{ sx: { width: wide ? { xs: "calc(100% - 24px)", md: "85vw" } : undefined,
      maxWidth: wide ? "1600px" : undefined, margin: { xs: "12px", sm: "24px" }, maxHeight: "calc(100dvh - 48px)", borderRadius: 3 } }}>
    <DialogTitle id={wide ? "work-editor-title" : "type-picker-title"} component="div" sx={{ padding: { xs: "16px 64px 16px 16px", sm: "24px 64px 24px 24px" }, borderBottom: "1px solid #dde5e8" }}>
      <h2>{title}</h2>{description && <p>{description}</p>}
      <IconButton aria-label="Close" disabled={busy} onClick={onClose} sx={{ position: "absolute", right: 16, top: 16 }}><Close /></IconButton>
    </DialogTitle>
    <DialogContent sx={{ p: { xs: 2, sm: 3 } }}>{children}</DialogContent>
    <DialogActions className="schedule-editor-actions" sx={{ p: { xs: 2, sm: 3 }, borderTop: "1px solid #dde5e8" }}>{actions}</DialogActions>
  </Dialog></ScheduleEditorTheme>;
}
